import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import { apiSlice } from './slices/apiSlice'
const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        [apiSlice.reducerPath]: apiSlice.reducer,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
